<ol class="breadcrumb" fxFlex fxLayout="row" fxLayoutAlign="start center">
  <li
    *ngFor="let breadcrumb of breadcrumbItems; last as isLast; first as isFirst"
    class="breadcrumb-item"
    [ngClass]="{ active: isLast }"
    aria-current="page"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <a *ngIf="isFirst && !isLast" (click)="goBack()">
      <mat-icon class="ic-22">arrow_back_ios</mat-icon>
    </a>
    <a
      *ngIf="!isLast; else lastRoute"
      [routerLink]="breadcrumb.url"
      routerLinkActive="active"
    >
      {{ "breadcrumb." + breadcrumb.label | translate }}
    </a>
    <span *ngIf="!isLast" class="fc-9 pl-1">/</span>
    <ng-template #lastRoute>
      <span fxLayout="row" fxLayoutAlign="start center">
        <span *ngIf="!breadcrumb.dynamicLabel" [routerLink]="breadcrumb.url">{{
          "breadcrumb." + breadcrumb.label | translate
        }}</span>


        <span
          *ngIf="breadcrumb.dynamicLabel"
          style="text-transform: capitalize"
          [routerLink]="breadcrumb.url"
          >{{ breadcrumb.dynamicLabel }}</span
        >
        <span class="ml-1 fs-16" *ngIf="breadcrumb.id">
          #{{ breadcrumb.id }}
        </span>
        <span
          class="ml-1"
          fxLayout="row"
          fxLayoutAlign="center center"
          *ngIf="
            breadcrumb.label == 'details' &&
            breadcrumb.url.includes('transactions')
          "
        >
          <mat-icon
            ngxClipboard
            [cbContent]="breadcrumb.id"
            aria-hidden="false"
            aria-label="action"
            class="breadcrumb-icon-copy ic-18"
            svgIcon="icon_copy"
            (click)="copyIdPayment()"
          ></mat-icon>
        </span>
      </span>
    </ng-template>
  </li>
</ol>
